import { render, staticRenderFns } from "./BaseRadio.vue?vue&type=template&id=2458e75b&scoped=true&"
import script from "./BaseRadio.vue?vue&type=script&lang=js&"
export * from "./BaseRadio.vue?vue&type=script&lang=js&"
import style0 from "./BaseRadio.vue?vue&type=style&index=0&id=2458e75b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2458e75b",
  null
  
)

export default component.exports